const trim = (v: string | undefined, fallback: string) =>
  (v && v.trim() ? v.trim() : fallback).replace(/\/$/, '');

export const env = {
  apiUrl: trim(import.meta.env.VITE_API_URL, 'http://localhost:4000'),
  socketUrl: trim(import.meta.env.VITE_SOCKET_URL ?? import.meta.env.VITE_API_URL, 'http://localhost:4000'),
};
